import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Output,
  PLATFORM_ID,
} from '@angular/core';

@Component({
  selector: 'app-order-summary-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-summary-stats.component.html',
  styleUrl: './order-summary-stats.component.scss',
})
export class OrderSummaryStatsComponent {
  staticdata: any = [
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/a7be2907754232ff3eaa0d36dbfaf57f6917ae19?placeholderIfAbsent:true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      title: '1 Lac +',
      text: 'Order Fulfilled',
      altText: 'Orders icon',
      textWidth: '156px',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/279b02219febf3db01e376b91e35b311292981a9?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      title: '1 Lac +',
      text: 'Happy Customer Served',
      altText: 'Customers icon',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/18f9de949e936e21bf162c25142913a0f2fa16f3?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      title: '1 Lac +',
      text: 'Average Saving Per Part',
      altText: 'Savings icon',
    },
    {
      imageUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/0b9679ee1fe7dcd15ecdbb54b6c0d42370efb571?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      title: '1 Lac +',
      text: 'Scrap Available',
      altText: 'Scrap icon',
    },
  ];
}
